import { supabase } from '@/lib/supabase';

export const updateProjectName = async ({
  projectId,
  name,
}: {
  projectId: number;
  name: string;
}) => {
  const { error } = await supabase
    .from('projects')
    .update({ name })
    .eq('id', projectId);
  if (error) throw error;
};
